import { gsap, Power2 } from 'gsap';
import Swiper from 'swiper';

import { GetBy } from '../_app/cuchillo/core/Element';
import Win from '../_app/cuchillo/windows/Window';
import LoaderController from '../_app/cuchillo/loaders/LoaderController';
import { Basics } from '../_app/cuchillo/core/Basics';

export default class ModalGallery extends Win {
    _slider;
    _wrapper;
    _holder;

    _calls = {
        prevSlide: () => this.prevSlide(),
        nextSlide: () => this.nextSlide(),
    }

    constructor(__container, __id) {
        super(__container, __id);

        this._wrapper = GetBy.class('__slider', this.container)[0];
        this._holder = GetBy.class('__holder', this.container)[0];
        this.directHide();

        this._prev = GetBy.selector('[scroll-slider-prev]', this.container)[0];
        this._next = GetBy.selector('[scroll-slider-next]', this.container)[0];
    }

    prevSlide() {
        if (this._swiper) this._swiper.slidePrev();
    }

    nextSlide() {
        if (this._swiper) this._swiper.slideNext();
    }


    init(__id) {
        const gallery = KORA_GALLERY['Gallery__' + __id];
        if (!gallery) return;

        gallery.map(src => { this.addItem(src) });
        LoaderController._loaders.MediaLoader.addMoreMedia();

        this._swiper = new Swiper(GetBy.class('swiper-container', this.container)[0], {
            loop: true,
            pagination: false,
            slidesPerView: 1, // Ajusta según lo que necesites
            spaceBetween: 0, // Espacio entre las diapositivas
            autoplay: false,
            simulateTouch: false
        });

        this._prev.addEventListener(Basics.clickEvent, this._calls.prevSlide);
        this._next.addEventListener(Basics.clickEvent, this._calls.nextSlide);
    }

    destroy() {
        if (this._swiper) {
            this._swiper.destroy();
            this._swiper = null;

            this._prev.removeEventListener(Basics.clickEvent, this._calls.prevSlide);
            this._next.removeEventListener(Basics.clickEvent, this._calls.nextSlide);
        }

        this._holder.innerHTML = '';
    }

    addItem(src) {
        let media;

        // if (src.video) {
        //     media = document.createElement('video');
        //     media.setAttribute('data-video', '');
        //     media.setAttribute('controls', '');
        //     media.setAttribute('playsinline', '');
        //     media.setAttribute('webkit-playsinline', '');
        //     media.poster = '/assets/images/blank.png';
        //     media.width = src.width;
        //     media.height = src.height;
        //     media.src = src.video;
        // } else {
        media = document.createElement('img');
        media.src = '/assets/images/blank.png';
        // }

        media.setAttribute('data-src', src.image);
        media.setAttribute('data-item-load', '');
        media.setAttribute('data-scroll-slider-image', '');

        const item = document.createElement('div');
        item.classList.add('slider__item');
        item.classList.add('swiper-slide');
        item.appendChild(media);

        this._holder.appendChild(item);
    }

    show(__i = 0) {
        super.show();

        if (this._swiper) this._swiper.slideToLoop(__i);
    }

    show__effect(__d = 0) {
        gsap.to(this.container, { opacity: 1, duration: .5, ease: Power2.easeOut });
        gsap.to(this._wrapper, { opacity: 1, duration: .4, delay: .4, ease: Power2.easeOut, onComplete: () => { this.afterShow() } });
    }

    hide__effect(__d = 0) {
        gsap.to(this._wrapper, { opacity: 0, duration: .2, delay: .1, ease: Power2.easeOut });
        gsap.to(this.container, { opacity: 0, duration: .2, delay: .2, ease: Power2.easeOut, onComplete: () => { this.afterHide() } });
    }

    afterHide() {
        super.afterHide();

        if (this._prev) this._prev.removeEventListener(Basics.clickEvent, this._calls.prevSlide);
        if (this._next) this._next.removeEventListener(Basics.clickEvent, this._calls.nextSlide);
    }

    directHide() {
        gsap.set(this.container, { opacity: 0 });
        gsap.set(this._wrapper, { opacity: 0 });

        super.directHide();
    }

    resize() {
        super.resize();
        if (this._slider) this._slider.resize();
    }
}

export const WinModalGallery = new ModalGallery(GetBy.id('ModalGallery'), 'ModalGallery');
